import React from 'react';
import {RWebShare} from 'react-web-share';
import {isMobile} from '../../utils/commonMethods';
import {ic_outline_share_white} from '../../utils/images';
import './shareLinkButton.css';
import {globalConfigurableData, globalConst} from '../../utils/globalConstant';
import {TEST_API_D24} from '../../utils/apiUrl';

const ShareLinkButton = ({coupon, referText}) => {
  return isMobile() ? (
    <RWebShare
      data={{
        text: referText,
        title: globalConfigurableData?.appName,
        url: `${TEST_API_D24}?referCode=` + coupon,
      }}>
      <button className="coupon_button app-font-sub-text">
        {'Share Link'}
        <img
          style={{marginLeft: '5px'}}
          src={ic_outline_share_white()}
          height={15}
        />
      </button>
    </RWebShare>
  ) : (
    <div className="coupon_box">
      <div className="coupon_code">
        COPY CODE TO SHARE
        <p className="coupon_data">{coupon}</p>
      </div>
      <div>
        <button
          className="coupon_button"
          onClick={() => navigator.clipboard.writeText(coupon)}>
          Copy Code
        </button>
      </div>
    </div>
  );
};
export default ShareLinkButton;
